import FullPageModal from "@/modules/common/components/ui-kit/full-page-modal/full-page-modal";
import { Track } from "../../types";
import { useLinkedTracksQuery } from "../../hooks/linked-tracks.hook";
import LinkedTracksEmptyState from "./empty-state";
import AddNewTrack from "./add-new-track";
import { Box, Stack, Typography } from "@mui/material";
import TrackCard from "./track-card";

function LinkedTracksTabMobile({
  open,
  onClose,
  track,
}: Readonly<{
  open: boolean;
  onClose: () => void;
  track: Track;
}>) {
  const { data: linkedTracks } = useLinkedTracksQuery({
    uid: track.uid,
  });

  const hasLinkedtracks = linkedTracks && linkedTracks.length > 0;
  return (
    <FullPageModal
      isOpen={open}
      onClose={onClose}
      title={
        <Stack
          direction="row"
          alignItems="center"
          gap={(theme) => theme.nawy.spacing.xxs}
        >
          <Typography
            sx={(theme) => theme.nawy.typography.english.variants.headline.xs}
          >
            Linked Tracks
          </Typography>
          {hasLinkedtracks && (
            <Typography
              sx={(theme) =>
                theme.nawy.typography.english.variants.body.sm.regular
              }
            >
              ({linkedTracks.length})
            </Typography>
          )}
        </Stack>
      }
      extraButtons={
        Array.isArray(linkedTracks) &&
        linkedTracks.length > 0 && (
          <AddNewTrack track={track} hasLabel={false} />
        )
      }
    >
      {hasLinkedtracks ? (
        <Box
          sx={(theme) => ({
            display: "flex",
            flexDirection: "column",
            gap: theme.nawy.spacing.md,
            py: theme.nawy.spacing.md,
          })}
        >
          {linkedTracks?.map((track) => (
            <TrackCard key={track.uid} track={track} />
          ))}
        </Box>
      ) : (
        <LinkedTracksEmptyState track={track} />
      )}
    </FullPageModal>
  );
}

export default LinkedTracksTabMobile;
